import React, { useState } from 'react'
import Alert from 'react-s-alert'
import axios from 'axios'

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';


const UpdateCustomer = ({ name, projectID, email, phone, street, city, state, zip, getCustomer, setUpdateCustomer, updateCustomer, setViewCustomer, viewCustomer }) => {

  // const { name, projectID, email, phone, street, city, state, zip, getCustomer, setUpdateCustomer, updateCustomer } = props

  let names = name.split(' ')

  const [firstName, setFirstName] = useState(names[0])
  const [lastName, setLastName] = useState(names[1])
  const [emailA, setEmailA] = useState(email)
  const [phoneNumber, setPhoneNumber] = useState(phone)
  const [streetA, setStreetA] = useState(street)
  const [cityA, setCityA] = useState(city)
  const [stateA, setStateA] = useState(state)
  const [zipA, setZipA] = useState(zip)

  // console.log(stateA)

  let states = [
    { state: "California" },
    { state: "Colorado" },
    { state: "Florida" },
    { state: "Idaho" },
    { state: "Illinois" },
    { state: "Nevada" },
    { state: "New Jersey" },
    { state: "New Mexico" },
    { state: "North Carolina" },
    { state: "Oregon" },
    { state: "South Carolina" },
    { state: "Texas" },
    { state: "Utah" },
    { state: "Virginia" },
    { state: "Wyoming" }
  ]

  const updateCustomerInfo = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_customer_info', pid: projectID, FirstName: firstName, LastName: lastName, Email: emailA, Phone: phoneNumber, MailingStreet: streetA, MailingCity: cityA, MailingState: stateA, MailingPostalCode: zipA }).then((res) => {
      console.log(res.data)
      Alert.success(`Customer Info Updated`, {
        position: 'bottom-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
      getCustomer()
      setUpdateCustomer(!updateCustomer)
      setViewCustomer(false)
    })
  }


  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} >
      <div>
        <TextField style={{ width: 180 }} label={names[0]} size="small" margin="dense" onChange={e => setFirstName(e.target.value)}></TextField>
      </div>
      <div>
        <TextField style={{ width: 180 }} label={names[1]} size="small" margin="dense" onChange={e => setLastName(e.target.value)}></TextField>
      </div>
      <div>
        <span style={{fontWeight: 'bold'}} >CONTACT</span>
      </div>
      <div>
        <TextField style={{ width: 180 }} label={phone} size="small" type='number' margin="dense" onChange={e => setPhoneNumber(e.target.value)}></TextField>
      </div>
      <div>
        <TextField style={{ width: 180 }} label={email} size="small" margin="dense" onChange={e => setEmailA(e.target.value)}></TextField>
      </div>
      <div>
        <span style={{ fontWeight: 'bold' }} >ADDRESS</span>
      </div>
      <div>
        <TextField style={{ width: 180 }} label={street} size="small" margin="dense" onChange={e => setStreetA(e.target.value)}></TextField>
      </div>
      <div>
        <TextField style={{ width: 180 }} label={city} size="small" margin="dense" onChange={e => setCityA(e.target.value)}></TextField>
      </div>
      <div>
        <Autocomplete disableClearable id="tags-outlined-states" options={states} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.state}`} value={states.state} onChange={(event, value) => setStateA(value.state)} style={{ width: 180 }}
          renderInput={(params) => (
            <TextField   {...params} size="small" label={state} margin="dense"
            />
          )}
        />
      </div>
      <div>
        <TextField style={{ width: 180 }} label={zip} size="small" type='number' margin="dense" onChange={e => setZipA(e.target.value)}></TextField>
      </div>
      <div>
        <Button variant='outlined' onClick={()=> updateCustomerInfo()}>Update Customer</Button>
      </div>
      <div>
        <Button variant='outlined' style={{ fontSize: '.8rem' }} onClick={() => {viewCustomer ? setViewCustomer(!viewCustomer) : setUpdateCustomer(!updateCustomer)}} >Close</Button>
      </div>
    </div>
  )
}



export default UpdateCustomer

